module.exports = __webpack_public_path__ + "static/media/38-6.d7548a89.mp3";